import { useTheme } from 'styled-components';

import CustomIcon, { CustomIconColor } from '@components/utils/CustomIcon';
import { AlertIcon, InfoIcon } from '@assets/icons';
import { PaletteColor } from '@utils/types';

import { InfoNoteBox, InfoNoteContainerProps, InfoNoteMessage } from './style';

const getVariantIconColor = (variant: InfoNoteContainerProps['variant']) => {
  return variant === 'hes'
    ? ('fadedOrange' as const)
    : variant === 'warning'
    ? ('coral' as const)
    : undefined;
};
export const Note = ({
  children,
  color,
  backgroundColor,
  variant = 'generic',
  hideIcon,
  ...rest
}: React.PropsWithChildren<InfoNoteContainerProps>) => {
  const { palette } = useTheme();
  const containerProps = { color, paletteColor: color };
  const variantIconFill = getVariantIconColor(variant);
  const colorKey = variantIconFill ?? color;
  const fill = palette[colorKey as PaletteColor] ?? colorKey;
  const Icon = variant === 'warning' ? InfoIcon : AlertIcon;
  const iconProps: CustomIconColor = fill
    ? { fill }
    : { paletteColor: color as PaletteColor, color };
  return (
    <InfoNoteBox
      backgroundColor={backgroundColor}
      {...containerProps}
      {...rest}
      variant={variant}
      hideIcon={hideIcon}
    >
      {hideIcon ? null : (
        <CustomIcon icon={Icon} width={15} height={15} {...iconProps} />
      )}
      <InfoNoteMessage>{children}</InfoNoteMessage>
    </InfoNoteBox>
  );
};

export default Note;
